import { Component, ErrorHandler, Inject, ChangeDetectionStrategy, signal } from '@angular/core'
import { form } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { TuettuKieli } from '@lemon/core/model/common'

import { firstValueFrom } from 'rxjs'
import { KayttajaService } from './_angular/service/kayttaja.service'
import { arvonMuutokset } from './_jaettu-angular/_lomakkeet/arvon-muutokset'
import { LemonTranslationService } from './_jaettu-angular/service/lemon-translation.service'

export interface VaihdaKieliDialogData {
  tallenna: boolean
}

@Component({
  templateUrl: './vaihda-kieli.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VaihdaKieliDialog {
  kieli = form(signal<TuettuKieli>(this.translationService.nykyinenKieli))

  private _vaihdaKieli(kieli: TuettuKieli) {
    this.translationService.vaihdaKieli(kieli)
    if (this.data.tallenna) {
      this.kayttajaService.tallennaKayttajanKieli(kieli).catch(err => this._errorHandler.handleError(err))
    } else {
      this._merkitseJosKirjautumaton(kieli).catch(err => this._errorHandler.handleError(err))
    }
    this.dialogRef.close()
  }

  // tallenna: false on käytössä myös kirjautuneilla sivuilla (tervetuloa, ajopäiväkirja, tunnistautuminen),
  // joten kirjautumissivun valinta tunnistetaan auth-tilasta eikä dialogin datasta.
  private async _merkitseJosKirjautumaton(kieli: TuettuKieli) {
    const kayttajanTiedot = await firstValueFrom(this.kayttajaService.kayttajanTiedotObservable)
    if (!kayttajanTiedot) {
      this.translationService.merkitseKirjautumattomanValinta(kieli)
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: VaihdaKieliDialogData,
    private translationService: LemonTranslationService,
    private dialogRef: MatDialogRef<VaihdaKieliDialog>,
    private kayttajaService: KayttajaService,
    private _errorHandler: ErrorHandler,
  ) {
    arvonMuutokset(this.kieli).subscribe(kieli => this._vaihdaKieli(kieli))
  }
}
